import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import { Box, Button, Grid, Typography } from '@material-ui/core';

import StepperSubHeader from '../../../components/Header/StepperSubHeader.component';
import Loader from '../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../components/SharedDialog/SharedDialog.component';
import {
  ASSISTANCE_CANCELED,
  ASSISTANCE_FINISHED,
  ASSISTANCE_REJECTED,
  ASSISTANCE_STATUS_ACCEPTED,
  ASSISTANCE_STATUS_ON_ROAD,
  ASSISTANCE_STATUS_PENDING,
} from '../../../constants/assistance.constant';
import { useAssistanceDataContext } from '../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../context/auth/auth.provider';
import { useInterval } from '../../../helpers/useInterval';
import StatusAccepted from './Status/StatusAccepted.component';
import StatusCanceled from './Status/StatusCanceled.component';
import StatusFinished from './Status/StatusFinished.component';
import StatusOnRoad from './Status/StatusOnRoad.component';
import StatusPending from './Status/StatusPending.component';
import StatusRejected from './Status/StatusRejected.component';

const AssistancesStatus = () => {
  const {
    open,
    setOpen,
    loading,
    success,
    errors,
    cancelAssistance,
    checkAssistanceStatus,
    checkCurrentAssistance,
  } = useAssistanceDataContext();
  const history = useHistory();
  const { id }: any = useParams();
  const { assistance_status } = success;
  const [delay, setDelay] = useState<number | null>(null);

  const { embed } = useAuthDataContext();
  const redirectHome = () => {
    embed
      ? window.parent.postMessage({ return: 'overview' }, '*')
      : history.push('/dashboard');
  };

  useInterval(async () => {
    if (Number(id)) {
      checkAssistanceStatus(id);
    } else if (id === 'undefined') {
      checkCurrentAssistance();
    }
  }, delay);

  useEffect(() => {
    return () => {
      setDelay(null);
    };
  }, []);

  useEffect(() => {
    if (Number(id)) {
      checkAssistanceStatus(id);
      setDelay(6000);
    } else if (id === 'undefined') {
      checkCurrentAssistance();
      setDelay(6000);
    } else {
      redirectHome();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (errors.assistance_status) {
      redirectHome();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors]);

  const sendCancelAssistance = () => {
    cancelAssistance(id);
    setOpen(false);
  };

  const statusToRender: any = {
    [ASSISTANCE_STATUS_PENDING]: <StatusPending></StatusPending>,
    [ASSISTANCE_STATUS_ACCEPTED]: <StatusAccepted></StatusAccepted>,
    [ASSISTANCE_STATUS_ON_ROAD]: <StatusOnRoad></StatusOnRoad>,
    [ASSISTANCE_CANCELED]: <StatusCanceled></StatusCanceled>,
    [ASSISTANCE_FINISHED]: <StatusFinished></StatusFinished>,
    [ASSISTANCE_REJECTED]: <StatusRejected></StatusRejected>,
    default: <StatusPending></StatusPending>,
  };

  return (
    <>
      <Box display={loading ? 'block' : 'none'}>
        <Loader action={'Cargando información'}></Loader>
      </Box>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Typography variant="h6">
              ¿Estás seguro que querés cancelar el pedido de asistencia?
            </Typography>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={sendCancelAssistance}
                >
                  Sí, estoy seguro
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="secondary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  No, conservar pedido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <StepperSubHeader
        goBack={() => {
          redirectHome();
        }}
      ></StepperSubHeader>
      <Grid container justify="center" style={{ height: 'calc(100% - 4px)' }}>
        {assistance_status?.status
          ? statusToRender[assistance_status.status]
          : null}
      </Grid>
    </>
  );
};

export default AssistancesStatus;
